<script setup lang="ts">

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useKidActions } from '../model/kid-actions.hook'

defineOptions({
  name: 'KidActions',
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  deleteIcon,
  toggle,
  openDelete,
} = useKidActions()
</script>

<template>
  <div
    ref="containerRef"
    class="kid-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      title="Kid actions"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="kid-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Delete kid’s account"
          color="red"
          :prepend-icon="deleteIcon"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KidActions.scss" />
